module.exports = __webpack_public_path__ + "media/images/directemployers-logo-5ab049b694fa215642b77c00be2a5f77.jpg";